export const logintTypeCorpo = "COR";
export const logintTypeInd = "IND";
export const logintTypePolice = "POL";

export const histLogin = 0;
export const histTagExport = 1; //new /Corp
export const histTagExportImport = 2; //new /Corp
export const histTagExportImportUpdt = 3; //new /Corp
export const histTagUpdate = 4;
export const histTagSoldTag = 5;
export const histTagStolenTag = 6;
export const histCorpProfileUpdate = 7;
export const histCorpProfileDeleteSubEmail = 8;
export const histCorpProfileAddSubEmail = 9;
export const histIndProfileUpdate = 10;
export const histIndProfileTagAdd = 11; //new (ind)
export const histIndPolicyUpdate = 12;
export const histAdminCreateTag = 13;
export const histCorpProfileSendAdminEmail = 14;
export const histTagVerification = 15;
export const histTagDelete = 16;

export const histLogIdTranslateCode = [
  "148", //0
  "149",
  "150",
  "151",
  "158",
  "11", // 5
  "39",
  "152",
  "153",
  "154",
  "152", //10
  "155",
  "156",
  "158",
  "154b",
  "132", //15
  "160",
];

// export const statusIdTranslateArray = ["14", "10", "11", "39", "12", "13"];

export const exportFields = [
  "state",
  "tattoo",
  "tag_inventory",
  "serial",
  "internal",
  "brand",
  "model",
  "type",
  "user_name",
  "department",
  "service",
  "office",
  "date_init",
  "date_effective",
  "price",
];
export const exportFieldsTitle = [
  "29",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "26",
  "36", // "25",
  "27",
  "37",
  "647",
  "28",
];

export const statusReserved = 0;
export const statusActive = 1;
export const statusSold = 2;
export const statusStolen = 3;
export const statusLoan = 4;
export const statusInactive = 5;
export const statusIdArray = [0, 1, 2, 3, 4, 5]; //REs, Activ, Sold, Stolen, Loan, Inactiv
export const statusIdArraylabelId = ["14", "10", "11", "39", "12", "13"]; //REs, Activ, Sold, Stolen, Loan, Inactiv

export const modalConfig = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
};
export const modalConfigIgnorBack = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
};

//Is add/update , you need to replicate  in backend/common/common.js
export const emailTemplateVar = [
  { name: "{%ClientCode%}", emailLis: ["ACCOUNT_INFO_"] },
  { name: "{%UserEmail%}", emailLis: ["ACCOUNT_INFO_"] },
  { name: "{%Password%}", emailLis: ["ACCOUNT_INFO_"] },
  {
    name: "{%Company%}",
    emailLis: ["ACCOUNT_INFO_COR_", "EMAIL", "SOLD_", "SOLD_MULTI"],
  },
  { name: "{%Tag%}", emailLis: ["SOLD_", "STOLEN_"] },
  { name: "{%Brand%}", emailLis: ["SOLD_", "STOLEN_"] },
  { name: "{%Model%}", emailLis: ["SOLD_", "STOLEN_"] },
  // { name: "{%Status%}", emailLis: ["SOLD_", "STOLEN_"] },
  { name: "{%ReportNO%}", emailLis: ["SOLD_", "STOLEN_"] },
  { name: "{%SoldToName%}", emailLis: ["SOLD_"] },
  { name: "{%SoldToAddress%}", emailLis: ["SOLD_"] },
  { name: "{%SoldToEmail%}", emailLis: ["SOLD_"] },
  { name: "{%ClientType%}", emailLis: ["SOLD_", "STOLEN_"] },
  { name: "{%Name%}", emailLis: ["EMAIL"] },
  { name: "{%LastName%}", emailLis: ["EMAIL"] },
  { name: "{%Tags%}", emailLis: ["SOLD_MULTI", "STOLEN_MULTI"] },
  { name: "{%Count%}", emailLis: ["SOLD_MULTI", "STOLEN_MULTI"] },
];

// '{%ClientCode%}', '{%UserEmail%}','{%Password%}','{%Company%}',
// '{%Tag%}','{%Brand%}','{%Model%}','{%Status%}','{%ReportNO%}','{%SoldToName%}','{%SoldToAddress%}',
// '{%SoldToEmail%}', '{%ClientType%}'];
